import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.rolle-dienstplan-sichtbarkeit-festlegen';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungRolleDienstplanSichtbarkeitFestlegenEffects {

    RolleDienstplanSichtbarkeitFestlegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_ROLLE_DIENSTPLAN_SICHTBARKEIT_FESTLEGEN),
        mergeMap((x: ac.PostRolleDienstplanSichtbarkeitFestlegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postRolleDienstplanSichtbarkeitFestlegen(x.rolleDienstplanSichtbarkeitFestlegenRequest).pipe(
                map((result: any) => {
                    return new ac.PostRolleDienstplanSichtbarkeitFestlegenErfolgreichAction(result, x.rolleDienstplanSichtbarkeitFestlegenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostRolleDienstplanSichtbarkeitFestlegenFehlerAction(error, x.rolleDienstplanSichtbarkeitFestlegenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.RollenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.RollenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.RollenCommandService);
        }
        return this.service;
    }
}
